import request from '@/utils/request'

// 发送获取验证码
export function codeData(params) {
	return request.post('/v1/auth/mobileCode', params)
}

// 注册提交
export function registerSubmit(params) {
	return request.post('/v1/auth/familyFriendsGroupmobileRegister', params)
}